var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$data.content && _vm.length
    ? _c(
        "div",
        { staticClass: "text-reduction" },
        [
          _vm.length >= this.$data.content.length
            ? _c(
                "span",
                { staticClass: "text-nowrap", class: _vm.textClass },
                [
                  _vm._v(
                    "\n        " + _vm._s(this.$data.content) + "\n        "
                  ),
                  _vm._t("default")
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.length < this.$data.content.length
            ? [
                _c(
                  "span",
                  {
                    staticClass: "short-content text-nowrap",
                    class: _vm.textClass
                  },
                  [
                    _vm._v(
                      _vm._s(this.$data.content.substr(0, _vm.length)) + "..."
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "full-content",
                    class: { nowrap: _vm.nowrap, "right-align": _vm.right },
                    style: { "background-color": _vm.bg }
                  },
                  [_vm._v(_vm._s(this.$data.content) + " "), _vm._t("default")],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }